import { Component, OnInit, OnChanges, SimpleChanges, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InputBaseComponent } from 'projects/common-lib/src/lib/input/input-base-component';
import { ApiService } from 'projects/core-lib/src/lib/api/api.service';
import { UxService } from '../../services/ux.service';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputStaticComponent),
  multi: true
};

@Component({
  selector: 'ib-input-static',
  //inputs: ['name', 'label', 'width', 'size', 'bold', 'tight', 'vertical', 'border'],
  templateUrl: './input-static.component.html',
  styleUrls: ['./input-static.component.css'] ,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class InputStaticComponent extends InputBaseComponent implements OnInit, OnChanges, ControlValueAccessor {

  /**
  When true (the default) there is a border around the content so it looks like an input control.
  */
  @Input() public border: boolean = true;

  constructor(protected apiService: ApiService, protected uxService: UxService) {
    super(apiService, uxService);
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.configure();
    //console.error(`border = ${this.border}`);
  }

  public configure() {

    super.configure();

    // With undefined label we don't have proper alignment
    if (!this.label) {
      this.label = "   ";
    }

  }

}
